@if (selectedStep?.header) {
    <div class="modal-header position-relative justify-content-center" [class.modal-header-distinctive]="selectedStep?.headerDistinctive">
        <div class="d-flex flex-column align-items-center">
            <h3 class="modal-title fw-semi-bold">{{ stepTitle }}</h3>
            @if (selectedStep?.subtitle) {
                <span class="fs-6 text-muted mt-2">{{ selectedStep?.subtitle }}</span>
            }
            @if (postingAsTeamName) {
                <span class="badge bg-primary text-white fs-8 fw-semi-bold mt-3">Posting as {{ postingAsTeamName }}</span>
            }
        </div>
        <pp-button class="position-absolute end-0 pe-7"
            ariaLabel="Close"
            id="mediaUploadClose"
            [shape]="buttonShape.Square"
            [variant]="buttonVariant.Transparent"
            (buttonClick)="launchCancelConfirmationModal()">
            <img alt="Close" class="no-padding btn-close m-0 p-1" [src]="resolveImageIcon('cancel')" />
        </pp-button>
    </div>
}
<div class="modal-body flex-fill d-flex flex-column h-100">
    @if (selectedStep?.displayInFlowProgressBar) {
        <ul id="mediaUploadFlowSteps" class="nav nav-pills nav-justified mb-4">
            @for (step of steps; track step.identifier) {
                @if (step.displayInFlowProgressBar) {
                    <li class="nav-item position-relative">
                        <ng-container [ngTemplateOutlet]="navigationStep"
                            [ngTemplateOutletContext]="{
                                active: step.active,
                                completed: step.completed,
                                id: step.identifier,
                                name: step.name,
                                subStep: step.subStep,
                            }" />
                    </li>
                }
            }
            <ng-template #navigationStep let-active="active" let-completed="completed" let-name="name" let-stepIdentifier="stepIdentifier" let-subStep="subStep">
                <div attr.id="{{ stepIdentifier }}" class="nav-link" [class.active]="active" [class.sub-step]="subStep">{{ name }}</div>
                <div class="nav-link-icon">
                    <img alt="Step" class="nav-link-icon px-1 z-2 position-relative" [src]="completed ? '/assets/images/icons/check-circle-solid-primary.svg' : '/assets/images/icons/circle-primary.svg'" />
                </div>
            </ng-template>
        </ul>
    }
    <div [class.mt-7]="selectedStep?.displayInFlowProgressBar">
        <ng-container [ngComponentOutlet]="$safeNavigationMigration(selectedStep?.component)" [ngComponentOutletInputs]="{ completeFlow$, destroyFlow$, navigateToNextStep$, navigateToPreviousStep$, resetFlow$, uploadProgress, uploadComplete, processingComplete }" />
    </div>
</div>

<ng-template #mediaUploadCancelConfirmationModal>
    <div class="modal-body modal-action flex-fill p-7 overflow-y-auto">
        <span>Are you sure you want to cancel your upload? You may not be able to go back and retrieve this process.</span>
    </div>
    <div class="modal-footer d-flex gap-5">
        <pp-button class="m-0" [variant]="buttonVariant.Secondary" (buttonClick)="cancelFlow(false)">Go back</pp-button>
        <pp-button class="m-0" [variant]="buttonVariant.Destructive" (buttonClick)="cancelFlow(true)">Cancel</pp-button>
    </div>
</ng-template>
